import { commissionEnable, VUE_APP_MIDDLE_LAYER_API20 } from './env'
class Api {
    constructor() {
        this.commissionURl20 = VUE_APP_MIDDLE_LAYER_API20; //佣金中间件, 转发不同区域的佣金求情给对应的服务.
        this.commissionEnable = commissionEnable; // 设定 启用佣金设定功能
        this.changeable = true; // 设定 启用GM/UK
        this.enableDistribution = true; //设定 启用代理上层佣金分配
        this.profitURL = VUE_APP_MIDDLE_LAYER_API20 + '/profit';
    }
    getUrl(curArea, path) {
        return null
    }
    getUrl20(curArea, path) {
        let code = this.commissionURl20.substr(this.commissionURl20.length - 1, 1),
            URL = code == '/' ? this.commissionURl20 + curArea + path : this.commissionURl20 + '/' + curArea + '/' + path
        return URL
    }
}
export { Api }



// WEBPACK FOOTER //
// ./src/api/commissionEnv.js